import {token} from "@atlaskit/tokens";
import type {JourneyProgressStageState} from "./types";

function stageStateToBarColor(state: JourneyProgressStageState): string {
    switch (state) {
        case "completed":
            return token("color.icon.accent.green");
        case "skipped":
            return token("color.icon.accent.red");
        case "notStarted":
        default:
            return token("color.background.neutral");
    }
}

export function JourneyProgressSegment({
    label,
    state,
}: {
    label: string;
    state: JourneyProgressStageState;
}) {
    return (
        <div className="grid min-w-0 flex-1 grid-rows-[max-content_max-content] justify-items-center gap-y-ds-space-050">
            <div
                className="h-1.5 w-full rounded-full"
                style={{backgroundColor: stageStateToBarColor(state)}}
            />
            <span
                className="max-w-full truncate px-ds-space-025 text-center"
                style={{
                    color: token("color.text"),
                    textAlign: "center",
                    fontFamily: "Inter",
                    fontSize: 10,
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "normal",
                }}
                title={label}
            >
                {label}
            </span>
        </div>
    );
}
